<style lang="scss" scoped>
.day-configurator-time-planning {
    position: relative;
    $slotpadding: 48px;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Opera and Firefox */

    .intro-overlay {
        position: absolute;
        top: -16px;
        left: -16px;
        width: calc(100% + 32px);
        height: calc(100% + 32px);
        z-index: 1;

        &:before {
            position: absolute;
            width: 100%;
            height: 100%;
            background-color: #fff;
            opacity: 0.5;
        }

        p {
            max-width: 85vw;
            margin-left: auto;
            margin-right: auto;
            color: #172340;
            font-size: 1.25rem;
        }

        a {
            font-size: 1.5rem;
        }
    }

    .time-slot {
        padding-left: $slotpadding;
        position: relative;

        .slot-label {
            position: absolute;
            left: 0;
            top: 0;
            color: #cccccc;
            font-size: 0.75rem;
            font-weight: 300;
            transform: translateY(-50%);
            cursor: default;
        }

        .slot-inner {
            width: 100%;
            height: 100%;

            &.over {
                cursor: pointer;
            }
        }

        &.hour {
            .slot-inner {
                border-top: 1px solid #efefef;
            }
        }

        &:nth-child(4n + 2) {
            .slot-inner {
                border-bottom: 1px solid #efefef;
            }
        }
    }

    .card {
        position: absolute;
        top: 0;
        left: $slotpadding;
        width: calc(100% - #{$slotpadding});
        height: 120px; // hour offset
        border-radius: 4px;
        border: 1px solid #1f315a;
        //transition: top 0.15s ease-in-out;
        padding: 0 24px;

        @media screen and (max-width: 767.98px) {
            padding: 0 16px;
        }

        &.hover-card {
            pointer-events: none;
            background-color: rgba(31, 49, 90, 0.05);
            opacity: 0.5;
        }

        &.planned-card {
            &:hover {
                .drag-top,
                .drag-bottom {
                    opacity: 1;
                }
            }
        }

        .thumbnail {
            width: 46px;
            height: 46px;
            border-radius: 50%;
            object-fit: cover;
            font-family: "object-fit: cover";
            margin-right: 16px;
        }

        .icon {
            display: inline-block;
            margin-right: 8px;
            width: 24px;
        }

        .comment {
            margin-right: 16px;
        }

        p,
        a,
        span {
            line-height: 1.1875;
        }

        span {
            @media screen and (max-width: 767.98px) {
                font-size: 0.75rem;
            }
        }

        a {
            display: inline-block;
            position: relative;
            color: var(--accent);
            font-size: 0.875rem;
            font-weight: 300;
            text-decoration: underline;

            @media screen and (max-width: 767.98px) {
                font-size: 0.75rem;

                &:after {
                    content: "";
                    position: absolute;
                    top: -16px;
                    left: 0;
                    width: 100%;
                    height: calc(100% + 32px);
                }
            }
        }

        .tooltip-wrapper {
            position: relative;

            @media screen and (max-width: 767.98px) {
                position: absolute;
                right: 0;
                top: 0;
                line-height: 1.125rem;
            }

            &.icon-person {
                width: 6px;
            }

            &.icon-info {
                width: 12px;
            }

            .tooltip {
                position: absolute;
                width: 333px;
                z-index: 500;
                font-size: 0.875rem;
                font-weight: 200;

                p {
                    &:last-child {
                        font-size: 0.875rem !important;
                        font-weight: 200;
                    }
                }
            }

            .tooltip-icon {
                display: inline-block;
                cursor: pointer;

                ::v-deep svg {
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                }

                &:hover {
                    + .tooltip {
                        opacity: 1;
                        bottom: calc(100% + 8px);
                    }
                }
            }
        }

        &.card-single-row {
            .left-part,
            .right-part,
            .top,
            .bottom,
            .splitter {
                display: flex;
                flex-direction: row;
                align-items: center;
            }

            .left-part {
                @media screen and (max-width: 767.98px) {
                    width: 100%;
                }

                .splitter {
                    @media screen and (max-width: 767.98px) {
                        width: 100%;
                        justify-content: space-between;
                    }
                }
            }

            .top {
                position: relative;
                margin-right: 32px;
                p {
                    font-size: 1rem;
                }

                @media screen and (max-width: 767.98px) {
                    align-items: flex-start;
                    flex-direction: column;
                }
            }

            .comment {
                @media screen and (max-width: 767.98px) {
                    display: none;
                }
            }

            .right-part {
                span:last-child {
                    margin-left: 16px;
                }

                @media screen and (max-width: 767.98px) {
                    display: none;
                }
            }

            &.card-tiny {
                .left-part {
                    .splitter {
                        .top {
                            > p {
                                @media screen and (max-width: 767.98px) {
                                    display: none;
                                }
                            }
                        }
                    }
                }
            }
        }

        &.card-two-row {
            .left-part {
                display: flex;
                flex-direction: row;
                align-items: center;
                @media screen and (max-width: 767.98px) {
                    width: 100%;
                }

                .splitter {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    justify-content: center;
                    flex-grow: 0;
                    @media screen and (max-width: 767.98px) {
                        width: 100%;
                    }

                    .top {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        margin-bottom: 8px;
                        position: relative;
                        @media screen and (max-width: 767.98px) {
                            width: 100%;
                        }

                        p {
                            font-size: 1rem;
                        }

                        @media screen and (max-width: 767.98px) {
                            align-items: flex-start;
                            flex-direction: column;
                        }
                    }
                }
            }

            .right-part {
                display: flex;
                flex-direction: column;
                align-items: flex-end;

                span:last-child {
                    margin-top: 8px;
                }

                @media screen and (max-width: 767.98px) {
                    display: none;
                }
            }
        }
    }

    .listed-card,
    .activity-card {
        .card,
        &.card {
            border-color: var(--accent);
            background-color: var(--accent-light);
        }

        ::v-deep .handle {
            background-color: var(--accent) !important;
        }
    }

    .catering-card {
        .card,
        &.card {
            border-color: #e4e4e4;
            background-color: #f8f8f8;

            a {
                color: #1f315a;
            }
        }

        .spinner-background {
            display: none;
        }

        ::v-deep .handle {
            background-color: #e4e4e4 !important;
        }
    }

    .own-card,
    .break-card {
        .card,
        &.card {
            border-color: #1f315a;
            background-color: #f4f5f6;

            a {
                color: #1f315a;
            }
        }

        .spinner-background {
            display: none;
        }

        ::v-deep .handle {
            background-color: #1f315a !important;
        }
    }

    .card-overlay {
        pointer-events: none;
        position: absolute;
        top: 0;
        left: $slotpadding;
        width: calc(100% - #{$slotpadding});
        height: 100%;

        .resizable {
            left: 0;
            width: 100% !important;
            height: auto;
            transform: none;
            touch-action: none;
            position: absolute;
            box-sizing: border-box;
            pointer-events: all;
            //transition: height 0.15s linear/*, transform 0.15s linear*/;

            &:not(.resizing) .card {
                cursor: pointer;
            }

            &.active {
                z-index: 2 !important;

                .tooltip-fixed {
                    left: calc(100% + 16px);
                    opacity: 1;
                    pointer-events: all;
                }

                &:not(.resizing) .card {
                    cursor: grab;
                }

                &.dragging {
                    .card {
                        cursor: grabbing;
                    }

                    .tooltip-fixed {
                        opacity: 0;
                        pointer-events: none;
                    }
                }

                &.resizing {
                    .tooltip-fixed {
                        opacity: 0;
                        pointer-events: none;
                    }
                }
            }

            ::v-deep .handle {
                position: absolute;
                background-color: #1f315a;
                width: 120px;
                height: 4px;
                border-radius: 4px;
                left: 50%;
                z-index: 2;
                transform: translateX(-50%);
                transition: opacity 0.2s;
                //opacity: 0;
                -webkit-user-drag: none;

                &.handle-tm {
                    top: -2px;
                    cursor: n-resize;
                }

                &.handle-bm {
                    bottom: -2px;
                    cursor: s-resize;
                }

                @media screen and (max-width: 767.98px) {
                    height: 8px;

                    &.handle-tm {
                        top: -4px;

                        &:after {
                            content: "";
                            position: absolute;
                            bottom: 100%;
                            height: 40px;
                            width: 100%;
                            opacity: 0;
                        }
                    }

                    &.handle-bm {
                        bottom: -4px;

                        &:after {
                            content: "";
                            position: absolute;
                            top: 100%;
                            height: 40px;
                            width: 100%;
                            opacity: 0;
                        }
                    }
                }
            }
        }

        .card {
            left: 0;
            width: 100%;
        }
    }

    .spinner-background {
        display: block;
        position: absolute;
        top: -1px;
        left: -1px;
        width: calc(100% + 2px);
        height: calc(100% + 2px);
        background: rgba(255, 255, 255, 0.8);
        opacity: 0;
        transition: opacity 0.5s;
        pointer-events: none;

        &.visible {
            opacity: 1;
        }

        .spinner {
            position: absolute;
            top: calc(50% - 28px);
            left: 50%;
            width: 16px;
            height: 16px;
            &:before {
                left: -28px;
                width: 16px;
                height: 16px;
            }
            &:after {
                left: 28px;
                width: 16px;
                height: 16px;
            }
        }
    }

    .tooltip-fixed {
        position: fixed;
        width: 385px;
        z-index: 2;
        pointer-events: none;
        transition: opacity 0.3s !important;

        @media screen and (max-width: 1279.98px) {
            top: unset !important;
            bottom: 0;
            left: 0 !important;
            transform: none !important;
            width: 100vw;
            z-index: 6;
        }

        &.visible {
            pointer-events: all;
        }

        .tooltip-inner {
            h2 {
                font-size: 1.25rem;
            }

            p {
                font-size: 1rem;
                font-weight: 200;
            }

            a {
                display: inline-block;
                font-weight: 200;
            }

            .clickable {
                cursor: pointer;
            }

            .text-dark {
                text-decoration: underline;

                &:hover {
                    text-decoration: none;
                }
            }
        }
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>

<template>
    <div class="day-configurator-time-planning d-flex flex-column">
        <transition name="fade">
            <div class="intro-overlay d-md-none" v-if="showIntro" @click.stop="showIntro = false">
                <div class="text-center mt-56">
                    <p class="text-bold mb-32">Duid een tijdslot aan om een activiteit toe te voegen.</p>
                    <a class="text-accent font-weight-light">Begrepen</a>
                </div>
            </div>
        </transition>

        <div class="time-slots">
            <div class="time-slot" v-for="(slot,index) in totalSlots" :key="index" :class="{'hour': index % slotsPerHour === 0, 'occupied': occupiedSlots.includes(index)}" :style="{'height': `${hourSpacing/slotsPerHour}px`}">
                <template v-if="occupiedSlots.includes(index)">
                    <span v-if="index % slotsPerHour === 0" class="slot-label">{{ `${start + (index/slotsPerHour)}:00` }}</span>
                    <div class="slot-inner">
                    </div>
                </template>
                <template v-else>
                    <drop @dragover="handleDragOver($event, index)" @drop="handleDrop" @dragleave="removeHoverState" class="h-100">
                        <span v-if="index % slotsPerHour === 0" class="slot-label">{{ `${start + (index/slotsPerHour)}:00` }}</span>
                        <div class="slot-inner" :class="{'over': currentHoverIndex === index}" @mouseover="handleMouseOver(index)" @click="clickTimeSlot(index)">
                        </div>
                    </drop>
                </template>
            </div>
        </div>

        <transition name="fade">
            <div v-if="isHovering" class="card hover-card card-two-row d-flex align-items-center justify-content-between" :class="`${hoverPayload.type}-card`" :style="{'top': hoverTopOffset}">
                <template v-if="hoverPayload.type === 'activity'">
                    <div class="left-part">
                        <img class="thumbnail align-self-start align-self-md-center" :src="hoverPayload.data.acf.content.images[0].sizes.medium_large" :alt="hoverPayload.data.post_title ? hoverPayload.data.post_title : hoverPayload.data.title.rendered">
                        <div class="splitter">
                            <div class="top">
                                <p v-html="hoverPayload.data.post_title ? hoverPayload.data.post_title : hoverPayload.data.title.rendered"></p>
                            </div>
                            <div class="bottom">
                                <p class="actions">
                                    <a class="comment">{{ translations.day_planning.add_remark }}</a>
                                    <a>{{ translations.day_planning.modify }}</a>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="right-part">
                        <span>{{ `${getTimeForIndex(currentHoverFirstSlotIndex)} - ${getTimeForIndex(currentHoverFirstSlotIndex + slotsPerHour)}` }}</span>
                        <span>1 uur</span>
                    </div>
                </template>
                <template v-if="hoverPayload.type === 'speaker' || hoverPayload.type === 'location' || hoverPayload.type === 'staticItem'">
                    <div class="left-part">
                        <img class="thumbnail align-self-start align-self-md-center" :src="hoverPayload.data.acf.image.sizes.medium_large" :alt="hoverPayload.data.post_title ? hoverPayload.data.post_title : hoverPayload.data.title.rendered">
                        <div class="splitter">
                            <div class="top">
                                <p v-html="hoverPayload.data.post_title ? hoverPayload.data.post_title : hoverPayload.data.title.rendered"></p>
                            </div>
                            <div class="bottom">
                                <p class="actions">
                                    <a class="comment">{{ translations.day_planning.add_remark }}</a>
                                    <a>{{ translations.day_planning.modify }}</a>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="right-part">
                        <span>{{ `${getTimeForIndex(currentHoverFirstSlotIndex)} - ${getTimeForIndex(currentHoverFirstSlotIndex + slotsPerHour)}` }}</span>
                        <span>1 uur</span>
                    </div>
                </template>
                <template v-if="hoverPayload.type === 'own_activity'">
                    <div class="left-part">
                        <div class="splitter">
                            <div class="top">
                                <span class="icon">{{ translations.day_planning.own_activity.icon }}</span>
                                <p>{{ hoverPayload.data.name }}</p>
                            </div>
                            <div class="bottom">
                                <p class="actions">
                                    <a class="comment">{{ translations.day_planning.add_remark }}</a>
                                    <a>{{ translations.day_planning.modify }}</a>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="right-part">
                        <span>{{ `${getTimeForIndex(currentHoverFirstSlotIndex)} - ${getTimeForIndex(currentHoverFirstSlotIndex + slotsPerHour)}` }}</span>
                        <span>1 uur</span>
                    </div>
                </template>
                <template v-if="hoverPayload.type === 'break'">
                    <div class="left-part">
                        <div class="splitter">
                            <div class="top">
                                <span class="icon">{{ translations.day_planning.break.icon }}</span>
                                <p>{{ translations.day_planning.break.label }}</p>
                            </div>
                            <div class="bottom">
                                <p class="actions">
                                    <a class="comment">{{ translations.day_planning.add_remark }}</a>
                                    <a>{{ translations.day_planning.modify }}</a>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="right-part">
                        <span>{{ `${getTimeForIndex(currentHoverFirstSlotIndex)} - ${getTimeForIndex(currentHoverFirstSlotIndex + slotsPerHour)}` }}</span>
                        <span>1 uur</span>
                    </div>
                </template>
            </div>
        </transition>

        <div class="card-overlay">
            <vue-draggable-resizable v-for="(item, index) in schedule.activities" :class="`${item.type}-card`" @resizing="resizing(index)" @resizestop="onResizestop" @dragging="dragging(index)" @dragstop="onDragstop" :min-height="hourSpacing/slotsPerHour" :parent="true" :handles="['tm', 'bm']" :key="index" :axis="'y'" :y="initialResizeOffsets[index]" :h="item.duration*2" :grid="[hourSpacing/slotsPerHour,hourSpacing/slotsPerHour]">
                <div class="card planned-card d-flex h-100 align-items-center justify-content-md-between" :class="item.duration <= 30 ? (item.duration <= 15 ? 'card-single-row card-tiny' : 'card-single-row') : 'card-two-row'">
                    <template v-if="item.type === 'listed' && getExternalItem(item) != null">
                        <div class="left-part">
                            <template v-if="item.data.external_type === 'activity'">
                                <img class="thumbnail align-self-start align-self-md-center" v-if="item.duration >= 45" :src="getExternalItem(item).acf.content.images[0].sizes.medium_large" :alt="getExternalItem(item).post_title ? getExternalItem(item).post_title : getExternalItem(item).title.rendered">
                            </template>
                            <template v-if="item.data.external_type === 'speaker' || item.data.external_type === 'location' || item.data.external_type === 'staticItem'">
                                <img class="thumbnail align-self-start align-self-md-center" v-if="item.duration >= 45" :src="getExternalItem(item).acf.image.sizes.medium_large" :alt="getExternalItem(item).post_title ? getExternalItem(item).post_title : getExternalItem(item).title.rendered">
                            </template>
                            <div class="splitter">
                                <div class="top">
                                    <p v-html="getExternalItem(item).post_title ? getExternalItem(item).post_title : getExternalItem(item).title.rendered"></p>
                                    <p class="d-md-none">
                                        <span class="d-inline-block mr-16">{{ `${item.start} - ${getTimeForIndex(Math.floor(getIndexForTime(item.start) + (item.duration/60*slotsPerHour)))}` }}</span>
                                        <span class="d-inline-block">{{ activityDurationString(item.duration) }}</span>
                                    </p>
                                    <div class="tooltip-wrapper icon-info ml-16" v-if="item.data.remarks && item.data.remarks != ''">
                                        <span class="tooltip-icon" v-html="svg('info-icon')">X</span>
                                        <div class="tooltip tooltip-top" v-html="item.data.remarks"></div>
                                    </div>
                                </div>
                                <div class="bottom">
                                    <p class="actions" v-if="canEdit">
                                        <a @click.stop="showRemarkPopup($event, {index: index, data: item})" class="comment">{{ item.data.remarks && item.data.remarks != '' ? translations.day_planning.change_remark : translations.day_planning.add_remark }}</a>
                                        <a @click.stop="showTooltip($event, {index: index, data: item})">{{ translations.day_planning.modify }}</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="right-part">
                            <span>{{ activityStartEndString(item) }}</span>
                            <span>{{ activityDurationString(item.duration) }}</span>
                        </div>
                    </template>
                    <template v-if="item.type === 'catering'">
                        <div class="left-part">
                            <div class="splitter">
                                <div class="top">
                                    <div class="d-flex flex-row align-items-center">
                                        <span class="icon">{{ translations.day_planning[item.data.type].icon }}</span>
                                        <p>{{ translations.day_planning[item.data.type].label }}</p>
                                    </div>
                                    <p class="d-md-none">
                                        <span class="d-inline-block mr-16">{{ `${item.start} - ${getTimeForIndex(Math.floor(getIndexForTime(item.start) + (item.duration/60*slotsPerHour)))}` }}</span>
                                        <span class="d-inline-block">{{ activityDurationString(item.duration) }}</span>
                                    </p>
                                    <div class="tooltip-wrapper icon-info ml-16" v-if="item.data.remarks && item.data.remarks != ''">
                                        <span class="tooltip-icon" v-html="svg('info-icon')">X</span>
                                        <div class="tooltip tooltip-top" v-html="item.data.remarks"></div>
                                    </div>
                                </div>
                                <div class="bottom">
                                    <p class="actions" v-if="canEdit">
                                        <a @click.stop="showRemarkPopup($event, {index: index, data: item})" class="comment">{{ item.data.remarks && item.data.remarks != '' ? translations.day_planning.change_remark : translations.day_planning.add_remark }}</a>
                                        <a @click.stop="showTooltip($event, {index: index, data: item})">{{ translations.day_planning.modify }}</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="right-part">
                            <span>{{ activityStartEndString(item) }}</span>
                            <span>{{ activityDurationString(item.duration) }}</span>
                        </div>
                    </template>
                    <template v-if="item.type === 'own'">
                        <div class="left-part">
                            <div class="splitter">
                                <div class="top">
                                    <div class="d-flex flex-row align-items-center">
                                        <span class="icon">{{ translations.day_planning.own_activity.icon }}</span>
                                        <p>{{ item.data.name }}</p>
                                    </div>
                                    <p class="d-md-none">
                                        <span class="d-inline-block mr-16">{{ `${item.start} - ${getTimeForIndex(Math.floor(getIndexForTime(item.start) + (item.duration/60*slotsPerHour)))}` }}</span>
                                        <span class="d-inline-block">{{ activityDurationString(item.duration) }}</span>
                                    </p>
                                    <div class="tooltip-wrapper icon-person ml-16" v-if="item.data.requests != null && item.data.requests != ''">
                                        <span class="tooltip-icon" v-html="svg('person-accent')">X</span>
                                        <div class="tooltip tooltip-top">
                                            <p class="font-weight-normal mb-8">{{ translations.day_planning.own_activity.tooltip_label }}</p>
                                            <p>{{ item.data.requests }}</p>
                                        </div>
                                    </div>
                                    <div class="tooltip-wrapper icon-info ml-16" v-if="item.data.remarks && item.data.remarks != ''">
                                        <span class="tooltip-icon" v-html="svg('info-icon')">X</span>
                                        <div class="tooltip tooltip-top" v-html="item.data.remarks"></div>
                                    </div>
                                </div>
                                <div class="bottom">
                                    <p class="actions" v-if="canEdit">
                                        <a @click.stop="showRemarkPopup($event, {index: index, data: item})" class="comment">{{ item.data.remarks && item.data.remarks != '' ? translations.day_planning.change_remark : translations.day_planning.add_remark }}</a>
                                        <a @click.stop="showTooltip($event, {index: index, data: item})">{{ translations.day_planning.modify }}</a>
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="right-part">
                            <span>{{ activityStartEndString(item) }}</span>
                            <span>{{ activityDurationString(item.duration) }}</span>
                        </div>
                    </template>
                    <template v-if="item.type === 'break'">
                        <div class="left-part">
                            <div class="splitter">
                                <div class="top">
                                    <div class="d-flex flex-row align-items-center">
                                        <span class="icon">{{ translations.day_planning.break.icon }}</span>
                                        <p>{{ translations.day_planning.break.label }}</p>
                                    </div>
                                    <p>{{ item.data.name }}</p>
                                </div>
                                <div class="bottom">
                                    <p class="actions" v-if="canEdit">
                                        <a @click.stop="showRemarkPopup($event, {index: index, data: item})" class="comment">{{ item.data.remarks && item.data.remarks != '' ? translations.day_planning.change_remark : translations.day_planning.add_remark }}</a>
                                        <a @click.stop="showTooltip($event, {index: index, data: item})">{{ translations.day_planning.modify }}</a>
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="right-part">
                            <span>{{ activityStartEndString(item) }}</span>
                            <span>{{ activityDurationString(item.duration) }}</span>
                        </div>
                    </template>

                    <div class="spinner-background" :class="{'visible': externalActivitiesLoaded === false}">
                        <div class="spinner"></div>
                    </div>
                </div>
            </vue-draggable-resizable>
        </div>

        <div class="tooltip tooltip-fixed tooltip-right px-16 py-24 px-md-32 py-md-24" ref="tooltip" :class="{'visible': tooltip.data != null}" :style="{'top': tooltipTop, 'left': tooltipLeft}" v-click-outside="tooltipClickOutside">
            <div class="tooltip-inner">
                <div class="d-flex justify-content-between align-items-center mb-8">
                    <template v-if="tooltip.data && tooltip.data.type === 'listed'">
                        <h2 class="d-inline-block mb-0" v-html="getExternalItem(tooltip.data) ? (getExternalItem(tooltip.data).post_title ? getExternalItem(tooltip.data).post_title : getExternalItem(tooltip.data).title.rendered) :''"></h2>
                    </template>
                    <template v-if="tooltip.data && tooltip.data.type === 'own'">
                        <h2 class="d-inline-block mb-0" v-html="tooltip.data.data.name"></h2>
                    </template>
                    <template v-if="tooltip.data && tooltip.data.type === 'catering'">
                        <h2 class="d-inline-block mb-0" v-html="translations.day_planning.catering.label"></h2>
                    </template>
                    <template v-if="tooltip.data && tooltip.data.type === 'break'">
                        <h2 class="d-inline-block mb-0" v-html="translations.day_planning.break.label"></h2>
                    </template>
                    <!--<a class="text-accent">{{ translations.day_planning.modify }}</a>-->
                </div>
                <div class="d-block">
                    <template v-if="tooltip.data && tooltip.data.data.remarks && tooltip.data.data.remarks != ''">
                        <p v-html="tooltip.data.data.remarks"></p>
                        <a @click.stop="showRemarkPopup($event, {index: tooltip.index})" class="text-dark">{{ translations.day_planning.change_remark }}</a>
                    </template>
                    <template v-else>
                        <p><a @click.stop="showRemarkPopup($event, {index: tooltip.index})" class="text-dark">{{ translations.day_planning.add_remark }}</a></p>
                    </template>
                </div>
                <hr class="mx-n32">
                <div class="d-flex justify-content-between align-items-center mb-16">
                    <span class="font-weight-bold">Tijd</span>
                    <p>{{ tooltipStartEndDate }}</p>
                </div>
                <hr class="mx-n32">
                <div class="d-flex justify-content-between align-items-center mb-16">
                    <span class="font-weight-bold">Duur</span>
                    <p>{{ tooltipDuration }}</p>
                </div>
                <template v-if="tooltip.data && tooltip.data.type === 'own'">
                    <hr class="mx-n32">
                    <div class="d-flex align-items-center mb-16 clickable" @click="toggleRequest(tooltip.index)">
                        <el-checkbox :value="tooltip.data.data.has_requests"></el-checkbox>
                        <p class="ml-12">Ik heb de hulp nodig van Inspire Your Tribe</p>
                    </div>
                    <div class="d-flex">
                        <p v-if="tooltip.data.data.requests != null && tooltip.data.data.requests != ''" v-html="tooltip.data.data.requests"></p>
                        <a v-else @click.stop="showRemarkPopup($event, {index: tooltip.index})" class="text-dark">{{ translations.day_planning.add_remark }}</a>
                    </div>
                </template>
                <template v-if="tooltip.data && tooltip.data.type === 'break'">
                    <hr class="mx-n32">
                    <div class="d-flex align-items-center mb-16 clickable" @click="toggleCatering(tooltip.index)">
                        <el-checkbox :value="tooltip.data.data.needs_catering"></el-checkbox>
                        <p class="ml-12">Catering toevoegen aan mijn break</p>
                    </div>
                    <p v-if="tooltip.data.data.needs_catering" v-html="tooltip.data.data.catering_remarks"></p>
                </template>
                <hr class="mx-n32">
                <div class="d-flex">
                    <a class="text-dark" @click="deleteActivity(tooltip.index)">Activiteit verwijderen</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
var cloneDeep = require('lodash.clonedeep');
import { Drag, Drop } from 'vue-drag-drop';
import VueDraggableResizable from 'vue-draggable-resizable'
import { bus } from '@/app';
import ClickOutside from 'vue-click-outside'
import AddRemarkModal from "./modals/day-configurator-add-remark-modal";
import AddItemModal from "./modals/day-configurator-add-item-modal";
import core from "./day-configurator-core";

export default {
    mixins: [core],

    components: {
        Drop,
        Drag,
        VueDraggableResizable
    },

    directives: { ClickOutside },

    data: () => ({
        showIntro: true,
        hourSpacing: 120,
        hoverOverIndex: -1,
        occupiedArray: [],
        hoverPayload: null,

        resizingIndex: -1,
        initialResizeOffsets: [],

        tooltip: {
            topOffset: -1,
            leftOffset: -1,
            index: -1,
            data: null
        }
    }),

    props: {
        start: {
            type: Number,
            required: true
        },
        end: {
            type: Number,
            required: true
        },
        items: {
            type: Object,
            required: true,
        },
        slotsPerHour: {
            type: Number,
            required: true
        },
    },

    created() {
        if (this.schedule.activities.length > 0) {
            this.initNewActivities(this.schedule.activities);
            this.showIntro = false;
        }

        bus.$on('hoverStateUpdate', (activity_object) => {
            this.hoverPayload = activity_object;
        });

        bus.$on('hideIntro', () => {
            this.showIntro = false;
        });

        bus.$on('planningUpdate', (planningUpdates) => {
            if (planningUpdates.remove && planningUpdates.remove.length > 0) {
                this.$store.dispatch('dayConfigurator/deleteActivities', planningUpdates.remove).then(() => {
                    while (planningUpdates.remove.length) {
                        this.initialResizeOffsets.splice(planningUpdates.remove.pop(), 1);
                    }
                    this.recalculateOccupiedIndexes();
                    this.$store.dispatch('dayConfigurator/update', { schedule: this.schedule, set: false });
                });
            }

            if (planningUpdates.add && planningUpdates.add.length > 0) {
                this.$store.dispatch('dayConfigurator/addActivities', planningUpdates.add).then(() => {
                    this.initNewActivities(planningUpdates.add);
                    this.$store.dispatch('dayConfigurator/update', { schedule: this.schedule, set: false });
                });
            }
        });
    },

    mounted() {
        const self = this;
        this.popupItem = this.$refs.tooltip;

        bus.$on('column-scroll', () => {
            self.hideTooltip();
        });
    },

    methods: {
        showTooltip(event, item) {
            this.tooltip.index = item.index;
            this.tooltip.data = item.data;

            let targetRectangle = event.target.closest(".card").getBoundingClientRect();
            this.tooltip.topOffset = targetRectangle.top + targetRectangle.height / 2;
            this.tooltip.leftOffset = targetRectangle.left + targetRectangle.width + 24;
        },

        hideTooltip() {
            this.tooltip.data = null;
            this.tooltip.index = -1;
        },

        tooltipClickOutside(event, el) {
            if (event.target.closest(".v--modal-overlay") == null) {
                this.hideTooltip();
            } else {
                // do nothing, click was in an overlay
            }
        },

        handleMouseOver(index) {
            this.hoverOverIndex = index;
        },

        handleDrop(payload) {
            if (payload != null) {
                if (payload.type === "activity" || payload.type === "speaker" || payload.type === "location" || payload.type === "staticItem") this.addActivity("listed", this.getTimeForIndex(this.currentHoverFirstSlotIndex), 60, payload);
                if (payload.type === "own_activity") this.addActivity("own", this.getTimeForIndex(this.currentHoverFirstSlotIndex), 60, payload);
                if (payload.type === "break") this.addActivity("break", this.getTimeForIndex(this.currentHoverFirstSlotIndex), 60, payload);
                this.recalculateOccupiedIndexes();
                this.removeHoverState();
            }
        },

        handleDragOver(event, index) {
            if (event.action == 'drop-item') {
                this.hoverPayload = event;
                this.hoverOverIndex = index;
            }
        },

        removeHoverState() {
            this.hoverPayload = null;
            this.hoverOverIndex = -1;
        },

        addActivity(type, start, duration, payload) {
            let activity_object = null;
            activity_object = this.makeActivityObject(type, start, duration, payload);
            if (type === 'listed') {
                this.$store.dispatch('dayConfigurator/addExternalActivity', payload.data).then(() => {
                    this.$store.dispatch('dayConfigurator/addActivity', activity_object).then(() => {
                        this.initialResizeOffsets.push(this.hourSpacing / this.slotsPerHour * this.getIndexForTime(activity_object.start))
                        this.$store.dispatch('dayConfigurator/update', { schedule: this.schedule, set: false });
                    });
                });
            } else {
                this.$store.dispatch('dayConfigurator/addActivity', activity_object).then(() => {
                    this.initialResizeOffsets.push(this.hourSpacing / this.slotsPerHour * this.getIndexForTime(activity_object.start))
                    this.$store.dispatch('dayConfigurator/update', { schedule: this.schedule, set: false });
                });
            }
        },

        deleteActivity(activity_index) {
            this.$store.dispatch('dayConfigurator/deleteActivity', activity_index).then(() => {
                this.$store.dispatch('dayConfigurator/update', { schedule: this.schedule, set: false });

                this.initialResizeOffsets.splice(this.tooltip.index, 1);
                this.recalculateOccupiedIndexes();
                this.hideTooltip();
            });
        },

        initNewActivities(activities) {
            if (activities.length > 0) {
                for (let i = 0; i < activities.length; i++) {
                    this.initialResizeOffsets.push(this.hourSpacing / this.slotsPerHour * this.getIndexForTime(activities[i].start))
                }
                this.recalculateOccupiedIndexes();
            }
        },

        activityStartEndString(activity) {
            if (activity != null) return `${activity.start} - ${this.getTimeForIndex(Math.floor(this.getIndexForTime(activity.start) + (activity.duration / 60 * this.slotsPerHour)))}`
            return '';
        },

        getTimeForIndex(index) {
            if (index < 0) {
                return null
            } else {
                let totalminutes = (this.start + (index / this.slotsPerHour)) * 60;
                let hours = (totalminutes / 60);
                let rhours = Math.floor(hours);
                let minutes = (hours - rhours) * 60;
                let rminutes = Math.round(minutes);

                let hourString = rhours < 10 ? `0${rhours.toString()}` : rhours.toString();
                let minutesString = rminutes < 10 ? `0${rminutes.toString()}` : rminutes.toString();

                return `${hourString}:${minutesString}`;
            }
        },

        getIndexForTime(time) {
            let splitTime = time.split(':')
            return (parseInt(splitTime[0]) - this.start) * 4 + (parseInt(splitTime[1]) / 15);
        },

        recalculateOccupiedIndexes() {
            let occupied = [];

            for (let i = 0; i < this.schedule.activities.length; i++) {
                let startTime = this.schedule.activities[i].start;
                let startIndex = this.getIndexForTime(startTime);
                occupied.push(startIndex);

                let durationInTimeslots = Math.round(this.schedule.activities[i].duration / 15);

                for (let j = 1; j < durationInTimeslots; j++) {
                    let remainingTakenTimeslot = startIndex + j;
                    occupied.push(remainingTakenTimeslot);
                }
            }

            this.occupiedArray = occupied;
        },

        resizing(index) {
            this.resizingIndex = index;
            this.hideTooltip();
        },

        onResizestop(left, top, width, height) {
            if (this.resizingIndex >= 0) {
                let activity_object = cloneDeep(this.schedule.activities[this.resizingIndex]);

                activity_object.duration = height / 2;

                let newStartSlotIndex = top / (this.hourSpacing / this.slotsPerHour);
                activity_object.start = this.getTimeForIndex(newStartSlotIndex);

                this.$store.dispatch('dayConfigurator/updateActivity', { activity_index: this.resizingIndex, activity_object: activity_object }).then(() => {
                    this.$store.dispatch('dayConfigurator/update', { schedule: this.schedule, set: false });
                    if (this.tooltip.data != null) this.tooltip.data = activity_object;
                });

                this.resizingIndex = -1;
                this.recalculateOccupiedIndexes();
            }
        },

        dragging(index) {
            this.resizingIndex = index;
            this.hideTooltip();
        },

        onDragstop(left, top) {
            if (this.resizingIndex >= 0) {
                let activity_object = cloneDeep(this.schedule.activities[this.resizingIndex]);

                let newStartSlotIndex = top / (this.hourSpacing / this.slotsPerHour);
                activity_object.start = this.getTimeForIndex(newStartSlotIndex);

                this.$store.dispatch('dayConfigurator/updateActivity', { activity_index: this.resizingIndex, activity_object: activity_object }).then(() => {
                    this.$store.dispatch('dayConfigurator/update', { schedule: this.schedule, set: false });

                    if (this.tooltip.data != null) this.tooltip.data = activity_object;
                });

                this.resizingIndex = -1;
                this.recalculateOccupiedIndexes();
            }
        },

        showRemarkPopup(event, item) {
            this.$modal.show(AddRemarkModal, item, { adaptive: true, pivotY: this.$root.isMobile ? 1 : 0.5, width: '616', height: 'auto' })
        },

        toggleRequest(index) {
            let activity_object = cloneDeep(this.schedule.activities[index]);

            if (activity_object.type == 'own') {
                let newValue = !activity_object.data.has_requests;

                this.$store.dispatch('dayConfigurator/setActivityRequest', { activity_index: index, value: newValue }).then(() => {
                    this.$store.dispatch('dayConfigurator/update', { schedule: this.schedule, set: false });

                    if (this.tooltip.data != null) this.tooltip.data = activity_object;
                });
            }
        },

        clickTimeSlot(index) {
            if (this.canEdit) {
                if (this.hoverPayload != null) {
                    this.handleDrop(this.hoverPayload);
                } else {
                    bus.$emit('hideIntro');
                    this.$modal.show(AddItemModal, { items: this.items, start: this.getTimeForIndex(index) }, { adaptive: true, pivotY: this.$root.isMobile ? 1 : 0.5, width: '616', height: 'auto' })
                }
            }
        },

        toggleRemarks(index) {

        },
    },

    computed: {
        totalSlots() {
            return (this.end - this.start) * this.slotsPerHour;
        },

        currentHoverIndex() {
            return this.hoverOverIndex;
        },

        currentHoverFirstSlotIndex() {
            let firstSlotIndex = this.hoverOverIndex;
            if (this.hoverOverIndex < 2) {
                return 0;
            } else if (this.hoverOverIndex > (this.lastIndex - 2)) {
                return this.lastIndex - 4;
            } else {
                return this.hoverOverIndex - 2;
            }
        },

        lastIndex() {
            return (this.end - this.start) * this.slotsPerHour;
        },

        occupiedSlots() {
            return this.occupiedArray;
        },

        isHovering() {
            return this.hoverPayload != null;
        },

        hoverTopOffset() {
            return `${this.hourSpacing / this.slotsPerHour * (this.currentHoverFirstSlotIndex)}px`;
        },

        tooltipStartEndDate() {
            return this.tooltip.data != null ? this.activityStartEndString(this.tooltip.data) : '';
        },

        tooltipDuration() {
            return this.tooltip.data != null ? this.activityDurationString(this.tooltip.data.duration) : '';
        },

        tooltipTop() {
            return `${this.tooltip.topOffset}px`;
        },

        tooltipLeft() {
            return `${this.tooltip.leftOffset}px`;
        },

        tooltipHasRequest() {
            return this.tooltip.data.data.has_requests;
        }
    }
}
</script>